import { I18n } from "@aws-amplify/core";

import { fetchGet } from "../api/fetch";
import { getLov } from "../utils/lov";
import {
  REQUEST_PROFILES,
  RECEIVE_PROFILES,
  FAILED_FETCH_PROFILES,
  SET_FILTERS,
  SET_PROFILES_LOV,
} from "../constants/actionTypes";

export const fetchProfiles = () => {
  return async (dispatch, getState) => {
    if (!getState().profiles.isFetching) {
      dispatch({ type: REQUEST_PROFILES });
      try {
        let limit = 50;
        let offset = 0;

        let fullRes = [];
        let res = await fetchGet(`profiles?limit=${limit}&offset=${offset}`);
        let lastId;
        while (res.length === limit && res[res.length - 1].id !== lastId) {
          fullRes.push(...res);
          lastId = res[res.length - 1].id;
          offset += limit;
          res = await fetchGet(`profiles?limit=${limit}&offset=${offset}`);
        }
        fullRes.push(...res);

        dispatch({
          type: RECEIVE_PROFILES,
          profiles: fullRes,
        });
      } catch (e) {
        console.log(e);
        dispatch({ type: FAILED_FETCH_PROFILES });
      }
    }
  };
};

export const fetchLov = () => {
  return async (dispatch, getState) => {
    try {
      const lov = {
        tag: await getLov("tags"),
        carrier: await getLov(89),
        profileType: await getLov("profileTypes"),
        active: [
          {
            id: true,
            name_en: I18n.get("profiles_yes"),
            name_fr: I18n.get("profiles_yes"),
          },
          {
            id: false,
            name_en: I18n.get("profiles_no"),
            name_fr: I18n.get("profiles_no"),
          },
        ],
      };
      dispatch({
        type: SET_PROFILES_LOV,
        lov,
      });
    } catch (e) {
      console.log(e);
    }
  };
};

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: filters,
});
